var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "basicBreadCrumb" },
    [
      _c("el-breadcrumb-item", [_vm._v("基础设置")]),
      _vm._v(" "),
      _vm._l(_vm.breadcrumbList, function(item) {
        return _c(
          "el-breadcrumb-item",
          {
            key: item.id,
            class: { active: item.url === _vm.$route.path },
            attrs: { to: item.url }
          },
          [_vm._v(_vm._s(item.name))]
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c5bef22e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5bef22e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/breadcrumb/basicBreadCrumb.vue
// module id = null
// module chunks = 